// extracted by extract-css-chunks-webpack-plugin
module.exports = {"error":"MealCardModal-0f15552f7be05201"};